import { lightTheme, darkTheme } from '.';

const debuggerLightTheme = {
  ...lightTheme,
  text: {
    ...lightTheme.text,
    success: {
      ...lightTheme.text.success,
      lineHeight: '150%',
    },
    error: {
      ...lightTheme.text.error,
      lineHeight: '150%',
    },
    warn: {
      ...lightTheme.text.warn,
      lineHeight: '150%',
    },
    primary: {
      ...lightTheme.text.primary,
      lineHeight: '150%',
    },
    primaryBold: {
      ...lightTheme.text.primaryBold,
      lineHeight: '150%',
    },
    primarySmall: {
      ...lightTheme.text.primarySmall,
      lineHeight: '150%',
    },
    hoverable: {
      ...lightTheme.text.hoverable,
      lineHeight: '150%',
      error: {
        ...lightTheme.text.hoverable.error,
        lineHeight: '150%',
      },
    },
    hoverableBold: {
      ...lightTheme.text.hoverableBold,
      lineHeight: '150%',
      error: {
        ...lightTheme.text.hoverableBold.error,
        lineHeight: '150%',
      },
    },
  },
};

const debuggerDarkTheme = {
  ...darkTheme,
  text: {
    ...darkTheme.text,
    success: {
      ...darkTheme.text.success,
      lineHeight: '150%',
    },
    error: {
      ...darkTheme.text.error,
      lineHeight: '150%',
    },
    warn: {
      ...darkTheme.text.warn,
      lineHeight: '150%',
    },
    primary: {
      ...darkTheme.text.primary,
      lineHeight: '150%',
    },
    primaryBold: {
      ...darkTheme.text.primaryBold,
      lineHeight: '150%',
    },
    primarySmall: {
      ...darkTheme.text.primarySmall,
      lineHeight: '150%',
    },
    hoverable: {
      ...darkTheme.text.hoverable,
      lineHeight: '150%',
      error: {
        ...darkTheme.text.hoverable.error,
        lineHeight: '150%',
      },
    },
    hoverableBold: {
      ...darkTheme.text.hoverableBold,
      lineHeight: '150%',
      error: {
        ...darkTheme.text.hoverableBold.error,
        lineHeight: '150%',
      },
    },
  },
};

export {
  debuggerDarkTheme,
  debuggerLightTheme,
};
